import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CardFiltersComponent } from './card-filters.component';

@NgModule({
  declarations: [CardFiltersComponent],
  imports: [
    CommonModule,
    MatIconModule,
  ],
  exports: [CardFiltersComponent]
})
export class CardFiltersModule { }
